module.exports = __webpack_public_path__ + "assets/guide.7e858d64.svg";